import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { fetchAuthSession } from 'aws-amplify/auth';
import { CircularProgress, Box } from '@mui/material';

export default function RequireAuth({ children, allowedGroups = [] }) {
  const [authState, setAuthState] = useState({
    isLoggedIn: null,     // null = loading
    userGroups: []
  });
  
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const authSession = await fetchAuthSession();
        const isLoggedIn = !!authSession?.tokens?.accessToken;
        const userGroups = authSession?.tokens?.idToken?.payload['cognito:groups'] || [];
        
        setAuthState({
          isLoggedIn,
          userGroups
        });

        
      } catch (err) {
        console.error("Error checking auth session", err);
        setAuthState({
          isLoggedIn: false,
          userGroups: []
        });
      }
    };
    checkAuth();
  }, []);

  if (authState.isLoggedIn === null) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          backgroundColor: '#f5f5f5',
        }}
      >
        <CircularProgress size={60} sx={{ color: '#002244' }} />
      </Box>
    );
  }

  if (!authState.isLoggedIn) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Check group permissions if required
  if (allowedGroups.length > 0 && 
      !authState.userGroups.some(group => allowedGroups.includes(group))) {
    return <Navigate to="/dash" state={{ from: location }} replace />;
  }

  return children;
}